import React from "react";
import { useTranslation } from "react-i18next";
import { SORTING } from "../../../../constants/sorting";
import { ROW_SELECTION_PROP_TYPES } from "../../proptypes";

const DropdownSortingLabel = ({
	dataType,
	direction,
	preferredType,
	customLabels
}) => {
	const { t } = useTranslation();

	const getLabelByType = React.useCallback(
		(type, direction) => {
			switch (type) {
				case SORTING.TYPES.NUMBER:
					return direction === SORTING.DIRECTIONS.ASC
						? t("access.common.sortingLabels.number.asc")
						: t("access.common.sortingLabels.number.desc");
				case SORTING.TYPES.STRING:
					return direction === SORTING.DIRECTIONS.ASC
						? t("access.common.sortingLabels.string.asc")
						: t("access.common.sortingLabels.string.desc");
				case SORTING.TYPES.DATE:
					return direction === SORTING.DIRECTIONS.ASC
						? t("access.common.sortingLabels.date.asc")
						: t("access.common.sortingLabels.date.desc");
				case SORTING.TYPES.BOOLEAN:
					return direction === SORTING.DIRECTIONS.ASC
						? t("access.common.sortingLabels.boolean.asc")
						: t("access.common.sortingLabels.boolean.desc");
				default:
					return direction === SORTING.DIRECTIONS.ASC
						? t("access.common.sortingLabels.any.asc")
						: t("access.common.sortingLabels.any.desc");
			}
		},
		[t]
	);

	if (customLabels) {
		return customLabels[direction];
	}

	return getLabelByType(preferredType || dataType, direction);
};

DropdownSortingLabel.propTypes = {
	direction: ROW_SELECTION_PROP_TYPES.SortingDirections,
	dataType: ROW_SELECTION_PROP_TYPES.SortingTypes,
	preferredType: ROW_SELECTION_PROP_TYPES.SortingDirections,
	customLabels: ROW_SELECTION_PROP_TYPES.CustomSortingLabels
};

DropdownSortingLabel.defaultProps = {
	dataType: null,
	direction: null,
	preferredType: null,
	customLabels: null
};

export default DropdownSortingLabel;
